app.controller('thankYouController', ['$scope', '$location', '$cookies', 'progressBarService', 'PaymentConfService', function ($scope,  $location, $cookies, progressBarService, paymentConfService) {
    if ($cookies.get('TokenInfo') == undefined || $cookies.get('_trns') == undefined || localStorage.getItem('appInfo') == undefined) {
        $location.path('/login');
        $cookies.remove('_trns', { path: '/' });
        return;
    }

    progressBarService.showProgressBar();

    var data = $cookies.get('_trns');
    $cookies.remove('_trns', { path: '/' });
    
    paymentConfService.confirmPayment($scope, data);

    $scope.printDiv = function (divName) {
        var printContents = document.getElementById(divName).innerHTML;
        var popupWin = window.open('', '_blank', 'width=300,height=300');
        popupWin.document.open();
        popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + printContents + '</body></html>');
        popupWin.document.close();
    }

  

}]);

app.service('PaymentConfService', ['LoginService', 'progressBarService', 'UpgradeService', function (loginService, progressBarService, upgradeService) {
    this.confirmPayment = function ($scope, transID,paymentFrom) {
        upgradeService.getSubscriptionConfirmationDetails(transID).then(function (response) {
            if (response != null && response.data.message != undefined) {
                $scope.isSuccess = false;
                $scope.isSubscriptionError = true;
                progressBarService.hideProgressBar();
            }
            else {

                var data = response.data;
                $scope.paymentResponse = {
                    eSpectraRecurringBillFlag: data.eSpectraRecurringBillFlag,
                    subscriptionType: data.eSpectraOrderIsMonthly == 1 ? "Monthly" : "Annual",
                    subscriptionTerm: data.eSpectraOrderIsMonthly == 1 ? "month" : "year",
                    req_currency: "USD",
                    auth_amount: data.eSpectraCCAmt,
                    req_card_number: data.eSpectraCCLast4Num
                }

                setLocalValue("premiumType", "2");
                setLocalValue("isAutorenewed", data.eSpectraRecurringBillFlag);
                if (paymentFrom != "p") {
                    $scope.isSuccess = true;
                }
                $scope.isSubscriptionSuccess = true;

                var startdate = data.eSpectraOrderStartDate.substr(0, 10);
                var endDate = data.eSpectraOrderEndDate.substr(0, 10);
                var amount = $scope.paymentResponse.req_currency + ' ' + $scope.paymentResponse.auth_amount;

                loginService.refreshToken();

                progressBarService.hideProgressBar();

                sendPurchaseNotification(data.eSpectraEmail, data.eSpectraProductName, amount, startdate, endDate, data.eSpectraIsInstitution, data.eSpectraOrderIsMonthly, data.eSpectraFirstName, data.eSpectraRecurringBillFlag);
            }
        });
    }

    var sendPurchaseNotification = function (memberList, packageName, amount, startDate, endDate, isInstitution, isMonthly, firstName, isAutorenewal) {
        upgradeService.sendPurchaseNotification(memberList, packageName, amount, startDate, endDate, isInstitution, isMonthly, firstName, isAutorenewal);
    }
}])